export const TESTING_BADGE = 'Testing: PF hours ignored'

/**
 * S-02 row and S-04 header: shown while the clinic's testing switch is on (`testingIgnorePfHours`), so nobody forgets
 * to turn it off after a demo.
 */
export function TestingBadge({ on }: { on: boolean | undefined }) {
  if (on !== true) return null
  return (
    <span
      className="tag tag-amber"
      title="Patients can book outside Practice Fusion facility hours. Turn it off after testing."
    >
      {TESTING_BADGE}
    </span>
  )
}
